module.exports = __webpack_public_path__ + "img/Shoplazza.4be2d299.png";